import { colors } from '../variables';

export default {
  MuiInput: {
    styleOverrides: {
      underline: {
        '&:before': {
          borderBottom: 'none',
        },
        '&:hover:not(.Mui-disabled):before': {
          borderBottom: 'none',
        },
        '&:after': {
          borderBottom: 'none !important',
        },
      },
    },
  },
  MuiInputLabel: {
    styleOverrides: {
      root: ({ theme }: any) => ({
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: '1.25rem',
        marginBottom: 4,
        color:
          theme.palette.mode === 'light'
            ? colors.grey[100]
            : theme.palette.text.primary,
        '&.Mui-focused': {
          color:
            theme.palette.mode === 'light'
              ? colors.grey[100]
              : theme.palette.text.primary,
        },
      }),
    },
  },
  MuiInputBase: {
    styleOverrides: {
      root: ({ theme }: any) => ({
        minHeight: 36,
        height: 36,
        padding: '4px 10px',
        backgroundColor: 'transparent!important',
        fontSize: '0.875rem',
        fontWeight: 400,
        color:
          theme.palette.mode === 'light'
            ? colors.grey[80]
            : theme.palette.text.primary,
        borderRadius: 6,
        border: `1px solid ${
          theme.palette.mode === 'light' ? colors.grey[20] : colors.grey[60]
        }`,

        '&.MuiInputBase-multiline': {
          height: 'auto',
        },
        '&.MuiInput-underline': {
          '&:after': {
            borderBottom: `1px solid ${
              theme.palette.mode === 'light'
                ? colors.grey[80]
                : theme.palette.divider
            }`,
          },
        },
        '& input': {
          fontSize: '0.875rem',
          fontWeight: 400,
        },

        '& .MuiOutlinedInput-input': {
          padding: 0,
        },

        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: 0,
        },

        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderWidth: '0px!important',
        },

        '&.Mui-focused': {
          borderColor:
            theme.palette.mode === 'light'
              ? colors.grey[50]
              : theme.palette.text.primary,
        },

        '&.Mui-disabled': {
          backgroundColor: theme.palette.background.paper,
          cursor: 'not-allowed',
        },
        '& .MuiAutocomplete-input': {
          height: 0,
          padding: 0,
          minWidth: '0!important',
        },

        '& .MuiAutocomplete-tag': {
          marginTop: 0,
          marginBottom: 0,
          height: 22,
        },

        '& .MuiChip-root': {
          height: 22,
          marginTop: 3,
          marginBottom: 0,

          '&:first-of-type': {
            marginTop: 0,
          },
        },
        // '.reportRequired &': {
        //   boxShadow: '0 0 10px 0px #900',
        // },
      }),
    },
  },
  MuiCheckbox: {
    styleOverrides: {
      root: ({ theme }: any) => ({
        color:
          theme.palette.mode === 'light'
            ? colors.grey[20]
            : theme.palette.text.secondary,
        '&:hover': {
          backgroundColor: 'transparent',
        },
      }),
    },
  },
};
